module.exports = __webpack_public_path__ + "static/img/GalaxyTabS4.b770b69a.png";